import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Layouts } from '../app.component';
import { DataCatalogueComponent } from './data-catalogue.component';
import { DataTypeComponent } from './data-type/data-type.component';

const routes: Routes = [  {
    path : 'data-catalogue',
    component : DataCatalogueComponent,
    data: { layout: Layouts.SecureLayout }

},
// {
// path: 'data-catalogue/feature/data-type:dataType',
//  component: DataTypeComponent }


];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DataCatalogueRoutingModule { }